import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { IOptionFieldList } from 'src/Interfaces/AdminInterface';
import { AdminStore } from 'src/Stores/Admin/AdminStore';
import { UserStore } from 'src/Stores/User/UserStore';
import DataTable from '../../../DataTable';


interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class DynamicFieldLists extends React.Component {
    public props: any;
    public listDisposer: any;
    public formattedData: IList;
    public AdminStore: AdminStore;
    public UserStore: UserStore;
    
    private tableHeaders: any[] = [
        { content: 'Field List', 'class': 'align-left' },
        { content: 'Item Count', 'class': 'align-left' }
    ];

    public state = {
        fieldLists: [] as IOptionFieldList[],
        formattedData: this.formattedData
    };

    constructor(props: any) {
        super(props);
        this.UserStore = this.props.stores.UserStore;
        this.AdminStore = this.props.stores.AdminStore;
    }

    public componentDidMount() {
        this.createDisposer();

        this.AdminStore.getFieldLists();
    }

    public componentWillUnmount() {
        this.clearDisposer();
    }

    public createDisposer() {
        this.listDisposer = intercept(this.AdminStore, 'fieldLists', (change: any) => {
            this.setState({
                fieldLists: change.newValue
            }, () => {
                this.formatDataTable();
            });
            
            return change;
        });
    }

    public clearDisposer() {
        this.listDisposer();
    }

    public renderListName(fieldList: any) {
        return(
            <Link to={'/admin/fieldlists/' + fieldList.routeName}>{fieldList.fieldListName}</Link>
        );
    }

    public formatDataTable() {
        const formattedData: any[] = [];
        this.state.fieldLists.map((fieldList, index: number) => {
            if (this.UserStore.hasPermission(`Permissions.Admin.OptionalFieldLists.${fieldList.routeName}.Read`)) {
                const row = [
                    {
                        'class': 'align-left',
                        content: this.renderListName.bind(this, fieldList),
                        sortItem: fieldList.fieldListName,
                        type: 'render'
                    },
                    {
                        'class': 'align-left',
                        content: fieldList.optionalFieldListItems.length
                    }   
                ];
                formattedData.push(row);
            }
        });

        this.setState({
            formattedData: {
                headers: this.tableHeaders,
                rows: formattedData
            }
        });
    }

    public render() {
        return(
            <div>
                <Row className="header">
                    <Col md="6">
                        <h1 className="float-left">Optional Field Lists</h1>
                    </Col>
                    {/* 
                    No Ability to add new Field Lists in App
                    <Col md="6">
                        <Link to="/admin/fieldlists/new">
                            <Button className="primary float-right">
                                Add New Field List
                            </Button>
                        </Link>
                    </Col> */}
                </Row>
                <Row>
                    <Col xs="12">
                        <DataTable list={this.state.formattedData} />
                    </Col>
                </Row>
            </div>
        );
    }

}

export default DynamicFieldLists;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/DynamicFieldLists/DynamicFieldLists.tsx